export default "__VITE_ASSET__725f66bd__"